var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScrollimage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.2065 4.44346C46.3026 4.50267 46.3875 4.56858 46.4615 4.63818L46.4273 4.65719C46.3592 4.58385 46.2856 4.51223 46.2065 4.44346ZM47.8393 9.37381C47.8529 9.18055 47.8356 8.98086 47.7851 8.77863C47.7214 8.52408 47.617 8.28975 47.4456 8.09321C47.2725 7.89455 47.0569 7.7643 46.8182 7.67903C46.373 7.52002 45.7844 7.4999 45.1 7.4999H45.0853L45.0706 7.50077C44.2656 7.54812 43.7144 7.44809 43.3486 7.26519C43.0036 7.09267 42.7915 6.83148 42.6789 6.45623L42.6767 6.44897L42.6743 6.44179C42.6326 6.31647 42.6084 6.19275 42.6018 6.07148C42.6072 6.09335 42.613 6.11528 42.6192 6.13726L42.6222 6.14771L42.6257 6.15802C42.7754 6.60732 43.0926 6.92448 43.5419 7.07424C43.7586 7.14647 44.0143 7.17372 44.2612 7.18671C44.5119 7.19991 44.7978 7.1999 45.0907 7.1999H45.1H45.1132L45.1263 7.19921C46.0424 7.15099 46.6077 7.2546 46.9755 7.45264C47.3187 7.63747 47.5527 7.93913 47.7257 8.45802L47.7322 8.47775L47.7404 8.49686C47.8608 8.77773 47.8917 9.01438 47.8661 9.22783C47.8603 9.27594 47.8514 9.32454 47.8393 9.37381Z",
    fill: "white",
    stroke: "url(#paint0_linear_53_105)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3947 3.80695L50.4059 3.79253L50.416 3.77733C50.5216 3.61893 50.6378 3.47516 50.7632 3.34595C50.6932 3.44229 50.6274 3.54431 50.5659 3.65191C50.0976 4.47151 49.9955 5.38689 50.1031 6.35519C50.2178 7.38776 50.6814 8.1885 51.3465 8.85353C51.4817 8.98873 51.6189 9.10779 51.7587 9.21098C51.4876 9.11083 51.2327 8.9745 51 8.79998C50.3251 8.29377 49.8811 7.52409 49.6963 6.53418C49.6083 5.43322 49.7966 4.57597 50.3947 3.80695Z",
    fill: "white",
    stroke: "url(#paint1_linear_53_105)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2163 8.79995L59.68 6.09995H59.9C59.9733 6.09995 60.0459 6.09724 60.1178 6.09176L60.4295 6.43571L62.5721 8.79995H62.2163ZM62.0464 5.0464C61.9213 5.17159 61.7731 5.28262 61.6128 5.37177C61.9355 4.98663 62.1 4.4797 62.1 3.89995C62.1 3.33744 61.9274 2.86779 61.6223 2.5147C61.7188 2.56743 61.8074 2.62616 61.8877 2.69039C62.2782 3.00283 62.5 3.46321 62.5 3.89995C62.5 4.37627 62.3465 4.7463 62.0464 5.0464ZM58.0065 2.19995H58.2967L58.3002 2.3151L58.3728 4.70842L58.3614 4.69638L58.4002 6.01465L58.4851 8.89995H58.0935L58.0065 2.19995Z",
    fill: "white",
    stroke: "url(#paint2_linear_53_105)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4 8.09997L65.4001 8.09993L65.3947 8.093C64.7861 7.3106 64.6181 6.45917 64.7903 5.59803L64.7904 5.59804L64.7919 5.58941C64.974 4.58811 65.4197 3.8102 66.1 3.29997L66.1001 3.30003L66.107 3.29465C66.2082 3.2159 66.3106 3.14452 66.4141 3.08031C66.3915 3.1019 66.3689 3.12394 66.3464 3.14642C65.6559 3.83701 65.324 4.63727 65.1119 5.59151C64.8924 6.57929 65.0927 7.46134 65.4943 8.21822C65.4616 8.17959 65.4302 8.14017 65.4 8.09997ZM70.193 8.80529C70.0918 8.88405 69.9894 8.95543 69.8859 9.01964C69.9085 8.99805 69.9311 8.97601 69.9536 8.95353C70.6441 8.26293 70.976 7.46267 71.1881 6.50844L71.194 6.48205L71.1969 6.45519C71.299 5.53676 71.2124 4.66593 70.8036 3.87928C70.8371 3.91869 70.8692 3.95892 70.9 3.99997L70.8999 4.00002L70.9053 4.00694C71.5139 4.78935 71.6819 5.64077 71.5097 6.50191L71.5045 6.5281L71.5021 6.5547C71.4166 7.49484 71.0025 8.17573 70.193 8.80529Z",
    fill: "white",
    stroke: "url(#paint3_linear_53_105)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.687 10.5722L73.3217 10.4634L75.2354 4.02624L75.581 4.13257L73.7203 10.4588L73.687 10.5722Z",
    fill: "white",
    stroke: "url(#paint4_linear_53_105)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81.667 6.15289L81.9406 6.26692L79.3408 12.3022L79.2853 12.431L79.0553 12.3339L81.667 6.15289Z",
    fill: "white",
    stroke: "url(#paint5_linear_53_105)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8388 10.79L91.2341 11.0504L91.1896 11.1144L89.5896 13.4144L89.3007 13.8297L89.3089 13.8353L89.184 14.0226L87.4613 16.6066L87.0949 16.3623L90.8388 10.79Z",
    fill: "white",
    stroke: "url(#paint6_linear_53_105)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M97 22.8H96.9773L96.9547 22.802C96.8077 22.8154 96.6644 22.8185 96.5241 22.8116C96.5702 22.807 96.6161 22.8018 96.662 22.7961C97.6273 22.6754 98.4261 22.081 99.0535 21.4535L99.0671 21.4399L99.0796 21.4254C99.7412 20.6535 100.084 19.8627 100.196 18.962C100.196 18.9605 100.197 18.959 100.197 18.9575C100.199 19.0046 100.2 19.0521 100.2 19.1V19.1227L100.202 19.1452C100.286 20.0705 99.9628 20.8443 99.3143 21.6815C98.692 22.388 97.9247 22.8 97 22.8ZM93.4 19.9C93.4 20.1551 93.4186 20.3975 93.4594 20.628C93.3512 20.3145 93.3 19.9729 93.3 19.6V19.5773L93.2979 19.5547C93.2138 18.6294 93.5372 17.8556 94.1857 17.0185C94.808 16.3119 95.5753 15.9 96.5 15.9H96.5227L96.5453 15.8979C96.884 15.8671 97.2025 15.8909 97.5112 15.9653C97.3205 15.9658 97.1285 15.98 96.938 16.0038C95.9726 16.1245 95.1739 16.719 94.5464 17.3464L94.5329 17.36L94.5204 17.3746C93.8588 18.1464 93.5164 18.9373 93.4039 19.838L93.4 19.8688V19.9Z",
    fill: "white",
    stroke: "url(#paint7_linear_53_105)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M101.325 29.1463L101.813 25.4843L101.877 25.5692L101.802 26.3526L101.515 29.3707L101.325 29.1463ZM103.982 26.7068C103.677 26.6559 103.414 26.5789 103.165 26.4405C103.204 26.4503 103.243 26.459 103.283 26.4664C103.843 26.5715 104.422 26.4205 104.929 25.9763C105.413 25.5528 105.69 25.0342 105.724 24.4677C105.728 24.4101 105.729 24.3527 105.727 24.2955C105.811 24.5465 105.839 24.7936 105.805 25.0293L105.8 25.0645V25.1C105.8 25.6206 105.592 26.0009 105.146 26.4464C104.903 26.6903 104.492 26.7918 103.982 26.7068ZM103.827 21.7049L103.998 21.9163L103.878 22.0171L101.378 24.1171L101.016 24.4215L101.038 24.45L98.8546 26.2132L98.6226 25.9554L103.827 21.7049Z",
    fill: "white",
    stroke: "url(#paint8_linear_53_105)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M111.749 36.958L112.619 36.11L112.846 36.0826L108.225 41.0328L108.011 40.603L111.749 36.958ZM109.67 32.9359L110.361 32.1742L110.826 32.1053L107.334 35.8594L106.571 36.6791L106.239 36.7193L109.67 32.9359Z",
    fill: "white",
    stroke: "url(#paint9_linear_53_105)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M109.837 43.2427L109.842 43.2332L109.847 43.2235C110.276 42.3657 110.952 41.8495 111.932 41.5823C112.92 41.3126 113.784 41.4074 114.557 41.837L114.567 41.8423L114.576 41.8471C114.796 41.9569 114.993 42.0829 115.17 42.226C115.051 42.1576 114.926 42.0957 114.797 42.0403C113.967 41.6845 112.948 41.6974 112.079 41.9148L112.06 41.9195L112.042 41.9256C111.063 42.2519 110.366 42.7067 109.793 43.5093C109.713 43.621 109.641 43.7327 109.577 43.8448C109.642 43.638 109.729 43.4375 109.837 43.2427ZM116.011 46.2841C116.089 46.1745 116.16 46.065 116.223 45.955C116.158 46.1618 116.071 46.3623 115.963 46.5571L115.958 46.5666L115.953 46.5763C115.524 47.4341 114.848 47.9503 113.868 48.2175L113.868 48.2174L113.856 48.221C112.988 48.4816 112.119 48.4002 111.224 47.9527C111.004 47.8429 110.807 47.7169 110.63 47.5738C110.749 47.6422 110.874 47.7041 111.003 47.7595L111.014 47.764L111.024 47.7681C111.935 48.1097 112.841 48.105 113.721 47.885L113.74 47.8803L113.758 47.8742C114.733 47.5493 115.535 46.9949 116.011 46.2841Z",
    fill: "white",
    stroke: "url(#paint10_linear_53_105)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M111.622 55.5542L113.987 52.6989L114.002 52.8498L114.405 52.8095L114.002 52.8498C114.015 52.9701 114.034 53.0874 114.061 53.201L113.824 53.4699L111.665 55.9267L111.622 55.5542ZM113.859 51.4135L111.121 51.7454L111.072 51.4299L117.777 50.5591L117.823 50.8682L117.538 50.9039L114.338 51.3039L113.854 51.3644L113.859 51.4135ZM116.35 54.7975C117.34 54.6984 117.936 54.0159 118.136 53.2278C118.14 53.7358 118.027 54.1586 117.784 54.5226C117.46 55.0091 117.08 55.2298 116.618 55.3068C116.203 55.376 115.842 55.2536 115.412 54.9096C115.278 54.8022 115.163 54.6878 115.066 54.5659C115.44 54.7668 115.881 54.8444 116.35 54.7975Z",
    fill: "white",
    stroke: "url(#paint11_linear_53_105)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M118.41 58.1064L118.416 58.4H118.2H115.4H115.3H114.885H114.8H111.9H111.714L111.71 58.1934L118.41 58.1064Z",
    fill: "white",
    stroke: "url(#paint12_linear_53_105)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M111.821 65.1149L111.762 65.1H111.7C111.677 65.1 111.634 65.0896 111.584 65.0299C111.532 64.9675 111.5 64.8801 111.5 64.8C111.5 64.7742 111.503 64.7607 111.505 64.7556C111.505 64.7553 111.506 64.7548 111.507 64.7543C111.525 64.7408 111.605 64.7 111.8 64.7C111.823 64.7 111.866 64.7103 111.916 64.77C111.968 64.8324 112 64.9198 112 65C112 65.0263 111.988 65.0591 111.95 65.0875C111.912 65.116 111.865 65.1259 111.821 65.1149Z",
    fill: "white",
    stroke: "url(#paint13_linear_53_105)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M110.568 74.9045C110.741 75.029 110.942 75.1247 111.171 75.1829C111.401 75.2478 111.642 75.2707 111.886 75.2237C112.135 75.1759 112.358 75.0617 112.556 74.8979C112.932 74.587 113.244 74.0788 113.548 73.4228C113.929 72.7115 114.278 72.2998 114.612 72.0802C114.918 71.8794 115.249 71.8144 115.676 71.8858C115.855 71.9471 116.007 72.0134 116.136 72.0885C116.075 72.0632 116.012 72.041 115.947 72.022C115.447 71.8599 114.959 72.0343 114.646 72.3463C114.399 72.5935 114.072 73.0401 113.755 73.6709C113.318 74.4961 112.944 74.949 112.583 75.1772C112.252 75.3865 111.873 75.442 111.312 75.3127L111.297 75.3092L111.282 75.3067C111.022 75.2633 110.776 75.138 110.568 74.9045ZM115.3 76.047C115.449 76.013 115.592 75.9618 115.735 75.8912C115.578 75.991 115.433 76.056 115.3 76.0916V76.047Z",
    fill: "white",
    stroke: "url(#paint14_linear_53_105)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M112.172 77.7474C113.197 78.4062 113.798 79.0312 114.139 79.7946C114.174 79.8815 114.206 79.9677 114.235 80.0533C114.235 80.0528 114.234 80.0524 114.234 80.0519C113.769 79.2378 113.067 78.6618 112.058 78.3257C111.118 78.0125 110.208 77.8802 109.371 78.1169C109.1 78.1855 108.854 78.2844 108.635 78.4088C108.912 78.1371 109.235 77.9217 109.594 77.7607C110.458 77.4176 111.308 77.4131 112.172 77.7474Z",
    fill: "white",
    stroke: "url(#paint15_linear_53_105)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M104.019 87.6402L107.59 86.8286L107.469 87.0464C107.456 87.0673 107.443 87.0884 107.431 87.1096L106.987 87.2129L103.836 87.9457L104.019 87.6402ZM109.427 86.411L109.443 86.4075L108.353 85.7686L105.883 84.3209L106.083 83.9785L111.927 87.2929L111.701 87.7102L111.448 87.5658L109.427 86.411ZM108.276 90.0471C108.835 90.3265 109.397 90.4185 109.922 90.2716C109.808 90.334 109.689 90.3831 109.563 90.4192L109.552 90.4221L109.542 90.4256C109.053 90.5885 108.598 90.5844 108.141 90.3612C107.776 90.1379 107.551 89.8521 107.387 89.3785C107.379 89.3269 107.371 89.2759 107.365 89.2255C107.561 89.5591 107.867 89.8425 108.276 90.0471Z",
    fill: "white",
    stroke: "url(#paint16_linear_53_105)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M105.393 91.3946C106.132 91.9697 106.55 92.6785 106.677 93.4561C106.408 92.8305 105.977 92.3102 105.313 91.8096C104.533 91.146 103.625 90.7999 102.7 90.7999C102.548 90.7999 102.401 90.8093 102.26 90.8275C102.453 90.7618 102.649 90.7177 102.848 90.6977C103.859 90.6061 104.706 90.7946 105.371 91.3762L105.382 91.3857L105.393 91.3946ZM101.5 96.4999C102.274 97.0804 103.009 97.4324 103.848 97.4912C103.816 97.4953 103.784 97.499 103.752 97.5022C102.741 97.5938 101.894 97.4052 101.229 96.8236L101.215 96.8112L101.2 96.7999C100.525 96.2934 100.081 95.5231 99.896 94.5324C99.8816 94.367 99.8747 94.206 99.8759 94.0495C99.8876 94.1067 99.9006 94.164 99.9149 94.2212C100.146 95.1456 100.619 95.8395 101.5 96.4999Z",
    fill: "white",
    stroke: "url(#paint17_linear_53_105)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7606 96.7535L96.6902 96.6803L96.9802 96.4064L101.584 101.271L101.325 101.505L96.7606 96.7535Z",
    fill: "white",
    stroke: "url(#paint18_linear_53_105)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4 100.8L92.25 100.6L92.5058 100.403L96.5935 105.796L96.3044 106.006L92.4 100.8Z",
    fill: "white",
    stroke: "url(#paint19_linear_53_105)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M84.879 105.469L87.9266 111.478L87.5018 111.69L87.4508 111.584L86.2508 109.084L86.1346 108.842L86.1708 108.824L85.9472 108.376L84.5708 105.624L84.879 105.469Z",
    fill: "white",
    stroke: "url(#paint20_linear_53_105)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0572 109.137L79.0667 109.142L79.0764 109.147C79.9328 109.575 80.4603 110.257 80.8274 111.165C81.0952 112.073 81.0749 113.016 80.6629 113.757L80.6577 113.767L80.6528 113.776C80.5272 114.027 80.3798 114.25 80.2114 114.449C80.2677 114.33 80.3197 114.205 80.3682 114.075C80.7106 113.162 80.7106 112.238 80.3682 111.324C80.0388 110.446 79.4889 109.673 78.8201 109.116L78.7863 109.088L78.7481 109.066C78.6367 109.002 78.5244 108.941 78.4107 108.885C78.638 108.941 78.8551 109.025 79.0572 109.137ZM74.4472 110.724C74.5397 110.538 74.6441 110.369 74.76 110.213C74.7146 110.313 74.672 110.417 74.6318 110.524C74.2894 111.438 74.2894 112.362 74.6318 113.275C74.9373 114.09 75.4322 114.814 76.0358 115.359L76.0333 115.358L76.0236 115.353C75.1607 114.921 74.6317 114.233 74.2642 113.314C73.926 112.469 73.9998 111.618 74.4472 110.724Z",
    fill: "white",
    stroke: "url(#paint21_linear_53_105)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0919 113.511L70.5839 110.716L70.8901 110.669L72.024 117.298L71.7147 117.355L71.694 117.223L71.3137 114.788L71.3261 114.798L71.2486 114.372L71.194 114.023L71.1135 113.507L71.0922 113.512L71.0919 113.511ZM67.8097 116.298C67.9262 116.88 68.2182 117.361 68.6575 117.672C68.4294 117.624 68.2186 117.55 68.0236 117.453C67.6013 117.242 67.3771 116.904 67.295 116.329L67.2951 116.329L67.2932 116.318C67.214 115.842 67.2886 115.49 67.5904 115.112C67.7733 114.884 67.9823 114.704 68.2242 114.559C68.1999 114.587 68.1764 114.616 68.1537 114.645C67.8056 115.098 67.6848 115.674 67.8097 116.298ZM69.602 113.81C69.5793 113.814 69.5567 113.819 69.5343 113.824L69.011 113.408L66.481 111.399L66.8683 111.331L69.9625 113.738L69.602 113.81Z",
    fill: "white",
    stroke: "url(#paint22_linear_53_105)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M54.716 116.525L54.9627 117.477L54.7033 118.086L52.96 111.445L53.4066 111.475L54.716 116.525ZM59.1216 116.845L59.437 117.884L59.2712 118.31L57.676 113.347L57.4181 112.545L57.6523 112.005L59.1216 116.845Z",
    fill: "white",
    stroke: "url(#paint23_linear_53_105)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5236 110.647L45.5515 110.633L45.5774 110.616C45.8352 110.444 46.1042 110.319 46.3864 110.235C46.1928 110.335 46.0012 110.456 45.8094 110.593L45.7942 110.604L45.7799 110.616C45.0828 111.197 44.6423 111.992 44.3257 112.942L44.3222 112.952L44.3192 112.963C44.0799 113.8 44.2093 114.715 44.5318 115.575L44.5359 115.586L44.5404 115.597C44.5415 115.599 44.5426 115.602 44.5437 115.605C44.5001 115.546 44.4576 115.485 44.416 115.423C43.9084 114.661 43.8075 113.804 43.9919 112.789L43.992 112.789L43.9932 112.782C44.1678 111.734 44.6716 111.073 45.5236 110.647ZM50.0483 111.577C49.9507 111.354 49.8316 111.142 49.6903 110.949C49.9449 111.184 50.1747 111.463 50.384 111.777C50.888 112.533 50.991 113.384 50.8119 114.389C50.5428 115.359 50.0191 116.053 49.2227 116.584C48.9537 116.763 48.6728 116.892 48.3773 116.975C48.5155 116.895 48.653 116.805 48.7906 116.707L48.8058 116.696L48.8201 116.684C49.5172 116.103 49.9577 115.308 50.2744 114.358L50.2825 114.334L50.2881 114.308C50.4979 113.364 50.5229 112.427 50.0483 111.577Z",
    fill: "white",
    stroke: "url(#paint24_linear_53_105)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8109 107.088L40.1348 110.646L39.9454 110.562L39.7635 110.112L38.4908 106.968L38.8109 107.088ZM40.7639 112.337L40.7722 112.359L41.2611 111.193L42.3734 108.541L42.7464 108.684L40.2226 114.95L39.7879 114.777L39.8642 114.586L40.7639 112.337ZM37.0358 111.714C36.8354 112.215 36.8098 112.704 36.9443 113.146C36.9083 113.09 36.8758 113.034 36.8472 112.976C36.6179 112.518 36.6095 112.062 36.7696 111.572C36.9159 111.217 37.2013 110.927 37.6581 110.774C37.6796 110.767 37.7008 110.76 37.722 110.754C37.4288 110.99 37.1951 111.316 37.0358 111.714Z",
    fill: "white",
    stroke: "url(#paint25_linear_53_105)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1101 111.721L32.8131 111.556L32.9319 111.352L34.3319 108.952L34.4455 108.757L34.4907 108.783L34.7363 108.344L36.1363 105.844L36.183 105.761L36.4167 105.891L33.1101 111.721Z",
    fill: "white",
    stroke: "url(#paint26_linear_53_105)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8465 102.546L30.7891 102.604L30.7528 102.676C30.7415 102.699 30.7311 102.707 30.7242 102.712C30.7155 102.718 30.6991 102.726 30.6714 102.729C30.608 102.738 30.5295 102.719 30.4774 102.684C30.4627 102.674 30.4208 102.63 30.4028 102.539C30.3848 102.449 30.4062 102.392 30.416 102.377C30.4258 102.363 30.4704 102.321 30.5606 102.303C30.6508 102.285 30.708 102.306 30.7227 102.316L30.7486 102.333L30.7764 102.347C30.8388 102.378 30.8651 102.425 30.8722 102.461C30.879 102.494 30.8711 102.522 30.8465 102.546Z",
    fill: "white",
    stroke: "url(#paint27_linear_53_105)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1102 99.9888L19.1498 100.011C19.1046 100.153 19.0749 100.304 19.0646 100.459C19.0559 100.283 19.0724 100.127 19.1102 99.9888ZM22.5096 102.388C22.3416 102.598 22.1247 102.733 21.8838 102.792C22.0522 102.709 22.2107 102.596 22.3536 102.454C22.6679 102.139 22.8425 101.646 22.6743 101.142C22.563 100.808 22.3497 100.381 22.0684 99.8187L22.0472 99.7764L22.0366 99.7551L22.024 99.735C21.5414 98.9628 21.3469 98.4053 21.3374 97.9764C21.3288 97.589 21.4702 97.2462 21.8283 96.8792C21.9065 96.8225 21.9898 96.7701 22.08 96.7237C22.0342 96.7623 21.9896 96.8033 21.9464 96.8464C21.7796 97.0133 21.6429 97.2088 21.5647 97.4434C21.486 97.6795 21.4769 97.9239 21.5198 98.1725C21.6012 98.6447 21.8781 99.1682 22.2816 99.7738C22.7122 100.444 22.9101 100.959 22.9388 101.361C22.9652 101.73 22.8519 102.041 22.5464 102.346L22.5269 102.366L22.5096 102.388Z",
    fill: "white",
    stroke: "url(#paint28_linear_53_105)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4453 97.202C16.2642 97.1855 16.0926 97.1568 15.9289 97.116C15.9952 97.113 16.0625 97.1076 16.1309 97.0998C17.05 97.0921 17.9517 96.7427 18.7254 96.0795C19.458 95.4516 20.0484 94.7679 20.2851 93.8212C20.3311 93.637 20.3645 93.4561 20.3822 93.2779C20.4227 93.5526 20.4303 93.8428 20.4023 94.1524C20.3164 95.0051 19.8927 95.7833 19.093 96.4052C18.2896 97.0302 17.4146 97.2901 16.4453 97.202Z",
    fill: "white",
    stroke: "url(#paint29_linear_53_105)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M14.854 84.4618L13.6704 88.0971L13.5371 87.8571L13.5308 87.8458L13.524 87.8349C13.5014 87.7987 13.478 87.7631 13.4539 87.728L13.5754 87.3547L14.6358 84.098L14.854 84.4618ZM9.53307 88.348C9.53019 88.3638 9.5275 88.3797 9.52501 88.3956C9.51421 88.2343 9.53094 88.0882 9.57435 87.958L9.58861 87.9152L9.59498 87.8706C9.67119 87.3372 9.97039 86.9608 10.3573 86.7287C10.7533 86.491 11.1022 86.4277 11.5419 86.5742C11.649 86.6099 11.7475 86.6487 11.8398 86.6929C11.4214 86.6438 10.9821 86.7268 10.5572 86.9628C9.98015 87.2834 9.63564 87.7838 9.53307 88.348ZM10.8911 91.1237L11.0481 91.034L13.8481 89.434L14.277 89.1889L14.2469 89.1347L14.2529 89.1312L16.7206 87.6847L16.9159 88.0195L11.0722 91.4211L10.8911 91.1237Z",
    fill: "white",
    stroke: "url(#paint30_linear_53_105)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7764 77.5472L10.795 77.5565L10.8143 77.5642C10.8391 77.5741 10.8638 77.5844 10.8882 77.5949C10.0793 77.4999 9.20006 77.5015 8.30854 77.9369C7.32193 78.2732 6.63157 78.8422 6.1715 79.6421C6.19909 79.5567 6.23 79.4713 6.26424 79.3857C6.60451 78.535 7.2886 77.9231 8.1857 77.5642L8.205 77.5565L8.22361 77.5472C9.08284 77.1176 9.91716 77.1176 10.7764 77.5472ZM12.7341 81.648C12.7684 81.5881 12.8009 81.5277 12.8317 81.4667C12.7877 81.682 12.7224 81.8977 12.6358 82.1143C12.2955 82.965 11.6114 83.5769 10.7143 83.9357C9.83351 84.2881 8.96649 84.2881 8.0857 83.9357C7.80189 83.8222 7.54466 83.6704 7.31454 83.4852C7.48735 83.5667 7.67509 83.6341 7.87873 83.685C8.75273 83.9035 9.67334 83.9144 10.6001 83.4589C11.4971 83.1157 12.2794 82.4439 12.7341 81.648Z",
    fill: "white",
    stroke: "url(#paint31_linear_53_105)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16494 75.5982L4.10634 75.3638L10.4213 73.7851L10.6186 73.7357L10.6925 74.0316L4.16494 75.5982Z",
    fill: "white",
    stroke: "url(#paint32_linear_53_105)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M2.72087 68.9474L2.67213 68.6305L9.16377 67.7959L9.39419 67.7662L9.44261 68.1617L2.72087 68.9474Z",
    fill: "white",
    stroke: "url(#paint33_linear_53_105)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83622 59.0752L2.12991 58.7268L2.15659 58.291L2.26438 58.2987L5.06438 58.4987L5.56941 58.5347L5.57216 58.488L5.77227 58.4992L8.86509 58.671L8.83622 59.0752Z",
    fill: "white",
    stroke: "url(#paint34_linear_53_105)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20847 46.2119L7.18208 46.206L7.15522 46.203C6.24016 46.1014 5.29967 46.0814 4.45193 46.5659C4.32107 46.6406 4.19302 46.7207 4.07004 46.8069C4.24853 46.6296 4.45128 46.4667 4.67735 46.316C5.4599 45.7943 6.32078 45.6168 7.28946 45.7881C8.28781 46.0639 8.96826 46.5038 9.48397 47.2773C9.60667 47.4614 9.71033 47.6497 9.79489 47.8428C9.72851 47.7538 9.65734 47.6654 9.58186 47.5772C8.99906 46.8792 8.19492 46.4311 7.20847 46.2119ZM3.71603 51.1226C3.65023 51.0239 3.58991 50.924 3.53508 50.8228C3.5619 50.8561 3.58958 50.8894 3.61812 50.9227C4.20092 51.6208 5.00507 52.0689 5.99153 52.2881C6.97171 52.5059 7.88262 52.4093 8.69228 51.9653C8.63728 52.0057 8.58074 52.0452 8.52265 52.084C7.73442 52.6094 6.86673 52.7857 5.88944 52.608C4.94177 52.4357 4.25213 51.9268 3.71603 51.1226Z",
    fill: "white",
    stroke: "url(#paint35_linear_53_105)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88571 41.3642L12.8342 40.1848L12.7089 40.5188L9.29326 41.9014L9.37436 41.658C9.38566 41.6241 9.39641 41.5901 9.40659 41.5558L9.88571 41.3642ZM5.05702 41.6733L5.33281 41.7711L7.6146 42.5808L7.54175 42.6103L8.71952 43.0662L11.3749 44.0941L11.289 44.3518L4.93835 42.0029L5.05702 41.6733ZM8.18571 38.8357C7.59318 38.5987 7.01204 38.6044 6.51585 38.8396C6.61301 38.7647 6.71488 38.7015 6.82362 38.6471C7.33618 38.3909 7.7921 38.3289 8.22786 38.4697C8.58212 38.6155 8.89504 38.9092 9.15034 39.3228C9.20149 39.4561 9.24344 39.596 9.27133 39.7432C9.04864 39.3491 8.68399 39.035 8.18571 38.8357Z",
    fill: "white",
    stroke: "url(#paint36_linear_53_105)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1221 26.6668L19.6273 28.5016L19.3714 28.9176L14.3338 27.5182L13.6055 27.3159L13.1221 26.6668ZM16.43 31.7565L16.7859 32.2243L11.9112 31.1125L11.0011 30.905L10.6246 30.4325L15.6888 31.5875L16.43 31.7565Z",
    fill: "white",
    stroke: "url(#paint37_linear_53_105)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M24 22.4C24 22.4778 23.9984 22.5543 23.9951 22.6294C23.8756 21.6919 23.403 20.8868 22.6254 20.2204C21.8536 19.5588 21.0627 19.2164 20.162 19.1039C20.0242 19.0866 19.8903 19.0771 19.7601 19.0754C19.9951 19.0249 20.2409 19 20.5 19C21.4906 19 22.2554 19.2625 22.9465 19.9536C23.6607 20.6678 24 21.4435 24 22.4ZM20.8869 25.8894C20.7931 25.8965 20.6975 25.9 20.6 25.9C19.6094 25.9 18.8446 25.6375 18.1536 24.9464C17.4393 24.2322 17.1 23.4565 17.1 22.5C17.1 22.4222 17.1016 22.3457 17.1049 22.2706C17.2244 23.2081 17.6971 24.0132 18.4746 24.6796C19.2002 25.3015 19.9741 25.7622 20.8869 25.8894Z",
    fill: "white",
    stroke: "url(#paint38_linear_53_105)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3671 18.3685L26.736 17.723L26.9 17.6C26.9699 17.5476 27.0366 17.4927 27.1001 17.4355L27.4106 17.4919L30.7176 18.0932L30.3671 18.3685ZM24.8524 17.3881L24.7706 17.3736L25.611 18.4142L27.3806 20.605L27.0993 20.8096L22.994 15.4815L23.2354 15.2861L23.4037 15.5049L24.8524 17.3881ZM25.9044 13.7759C25.5537 13.7552 25.2026 13.8248 24.8723 13.9667C25.3338 13.6377 25.8586 13.5 26.4 13.5C26.9235 13.5 27.288 13.7103 27.6096 14.1123C27.9115 14.4897 27.9861 14.8424 27.9068 15.3178C27.8897 15.4207 27.8651 15.5207 27.8324 15.619C27.7855 15.2656 27.6394 14.9191 27.4 14.6C27.013 14.084 26.4783 13.8096 25.9044 13.7759Z",
    fill: "white",
    stroke: "url(#paint39_linear_53_105)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3232 13.8891L31.402 13.8418L31.4713 13.9572L32.9713 16.4572L33.056 16.5983L32.6807 16.8165L29.2838 10.9807L29.5398 10.8319L29.6681 11.0519L31.0681 13.4519L31.3232 13.8891Z",
    fill: "white",
    stroke: "url(#paint40_linear_53_105)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2472 13.5763C38.212 13.5058 38.2138 13.448 38.2334 13.3931C38.2534 13.3371 38.2952 13.2793 38.3513 13.2349C38.4065 13.2139 38.4454 13.2205 38.4781 13.2345C38.526 13.255 38.596 13.3099 38.6528 13.4235C38.688 13.4939 38.6863 13.5518 38.6666 13.6067C38.6513 13.6498 38.623 13.6938 38.5853 13.7321C38.5032 13.7415 38.4387 13.7328 38.3932 13.7165C38.3416 13.6981 38.2905 13.6628 38.2472 13.5763Z",
    fill: "white",
    stroke: "url(#paint41_linear_53_105)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M60 53V67",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M67 60L60 67L53 60",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_53_105",
    x1: 47.5957,
    y1: 11.1677,
    x2: 44.2637,
    y2: 1.98794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D1582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_53_105",
    x1: 55.3283,
    y1: 9.55013,
    x2: 52.238,
    y2: 0.0912745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D1582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_53_105",
    x1: 62.9305,
    y1: 9.0373,
    x2: 59.7093,
    y2: 0.0523328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D1582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_53_105",
    x1: 71.0996,
    y1: 9.6039,
    x2: 68.3461,
    y2: 0.0653494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D1582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_53_105",
    x1: 77.0795,
    y1: 11.7854,
    x2: 72.3998,
    y2: 2.57467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D1582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_53_105",
    x1: 82.5167,
    y1: 14.0761,
    x2: 77.4986,
    y2: 4.99827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D1582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_53_105",
    x1: 93.7575,
    y1: 16.9609,
    x2: 91.5468,
    y2: 8.02647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D1582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_53_105",
    x1: 99.731,
    y1: 22.9417,
    x2: 96.9482,
    y2: 13.3017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D1582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_53_105",
    x1: 105.274,
    y1: 30.1479,
    x2: 101.52,
    y2: 18.7418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D1582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_53_105",
    x1: 112.422,
    y1: 41.4102,
    x2: 108.742,
    y2: 28.7873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D1582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_53_105",
    x1: 115.884,
    y1: 48.4948,
    x2: 113.098,
    y2: 38.8463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D1582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_53_105",
    x1: 117.626,
    y1: 56.7656,
    x2: 115.412,
    y2: 47.9738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D1582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_53_105",
    x1: 118.032,
    y1: 62.3645,
    x2: 116.854,
    y2: 55.9982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D1582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_53_105",
    x1: 112.314,
    y1: 65.5525,
    x2: 111.839,
    y2: 63.8131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D1582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_53_105",
    x1: 116.384,
    y1: 76.3263,
    x2: 114.535,
    y2: 68.3941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D1582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_53_105",
    x1: 113.981,
    y1: 84.3373,
    x2: 111.321,
    y2: 74.9514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D1582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_53_105",
    x1: 111.384,
    y1: 90.6748,
    x2: 109.175,
    y2: 80.9866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D1582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_53_105",
    x1: 106.25,
    y1: 97.6544,
    x2: 103.496,
    y2: 88.1143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D1582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_53_105",
    x1: 101.195,
    y1: 101.894,
    x2: 99.4677,
    y2: 93.6985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D1582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_53_105",
    x1: 96.2327,
    y1: 106.37,
    x2: 94.1801,
    y2: 97.6345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D1582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_53_105",
    x1: 87.8429,
    y1: 113.471,
    x2: 83.4897,
    y2: 103.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D1582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_53_105",
    x1: 80.5179,
    y1: 115.832,
    x2: 77.7549,
    y2: 106.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D1582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_53_105",
    x1: 71.694,
    y1: 117.854,
    x2: 68.5693,
    y2: 108.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D1582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_53_105",
    x1: 61.2341,
    y1: 118.714,
    x2: 58.8562,
    y2: 108.467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D1582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_53_105",
    x1: 50.4023,
    y1: 117.217,
    x2: 47.5996,
    y2: 107.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D1582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_53_105",
    x1: 42.5015,
    y1: 115.153,
    x2: 38.3572,
    y2: 104.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D1582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_53_105",
    x1: 36.0947,
    y1: 111.971,
    x2: 32.5782,
    y2: 101.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D1582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_53_105",
    x1: 31.191,
    y1: 103.164,
    x2: 30.6998,
    y2: 101.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D1582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_53_105",
    x1: 25.0997,
    y1: 102.98,
    x2: 22.5699,
    y2: 94.0507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D1582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_53_105",
    x1: 19.9113,
    y1: 97.3504,
    x2: 17.2543,
    y2: 87.7928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D1582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_53_105",
    x1: 16.5354,
    y1: 91.6666,
    x2: 13.1127,
    y2: 80.6111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D1582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_53_105",
    x1: 12.4196,
    y1: 84.3244,
    x2: 9.59867,
    y2: 74.6444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D1582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_53_105",
    x1: 10.332,
    y1: 75.8891,
    x2: 8.32853,
    y2: 67.6872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D1582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_53_105",
    x1: 9.01956,
    y1: 69.2268,
    x2: 7.4704,
    y2: 61.9173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D1582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_53_105",
    x1: 8.43197,
    y1: 59.3503,
    x2: 7.11368,
    y2: 52.6295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D1582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_53_105",
    x1: 9.58835,
    y1: 52.8006,
    x2: 6.79867,
    y2: 43.1368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D1582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_53_105",
    x1: 12.5334,
    y1: 44.6653,
    x2: 10.5852,
    y2: 35.7353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D1582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_53_105",
    x1: 19.0845,
    y1: 36.1008,
    x2: 15.3649,
    y2: 23.2158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D1582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_53_105",
    x1: 23.5196,
    y1: 26.0279,
    x2: 20.7474,
    y2: 16.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D1582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_53_105",
    x1: 30.7086,
    y1: 21.0997,
    x2: 28.023,
    y2: 10.5928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D1582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_53_105",
    x1: 35.7823,
    y1: 17.0666,
    x2: 32.231,
    y2: 6.1017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D1582"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_53_105",
    x1: 38.9992,
    y1: 14.1646,
    x2: 38.4514,
    y2: 12.3341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D1582"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollimage);
export default __webpack_public_path__ + "static/media/scrollimage.9bec495aa4e977da745b053285514175.svg";
export { ForwardRef as ReactComponent };